import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SqlService } from '../../Database/sql.service';
import * as XLSX from 'xlsx';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

type AOA = any[][];

@Component({
  selector: 'app-scan-box',
  templateUrl: './scan-box.component.html',
  styleUrls: ['./scan-box.component.css'],
})
export class ScanBoxComponent implements OnInit {
  StageOne = true;

  Provider = 0;

  p: number = 1;
  ItemsPerPage = 20;

  ProvidersData = [
    {
      ID: '',
      BoxSizeDirect: '',
      BatchSizeDirect: '',
      BoxSizeInDirect: '',
      BatchSizeInDirect: '',
    },
  ];

  Branch = '';
  Branchs = [''];

  date = '';

  excelFile = '';

  SERIALNUMBERs = [''];
  BrickNumbers = [''];
  BoxNUMBERs = [''];
  DataDisplay = [{ BoxNum: '', SerialNum: '', BrickNumber: '' }];

  formData = new FormData(); // Currently empty
  data: AOA = [
    [1, 2],
    [3, 4],
  ];

  ImportValid = false;

  closeResult = '';
  DisplayErrormessage = '';
  PopupTitle = '';

  CurrentDate = '';

  constructor(
    private dbService: SqlService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    let tempDate = new Date();
    this.CurrentDate = tempDate.getFullYear() + '-';
    let monthTemp = Number.parseInt(tempDate.getMonth().toString());
    monthTemp++;
    if (tempDate.getMonth().toString().length == 1) {
      this.CurrentDate += '0' + monthTemp + '-';
    } else {
      this.CurrentDate += monthTemp + '-';
    }

    if (tempDate.getDate().toString().length == 1) {
      this.CurrentDate += '0' + tempDate.getDate();
    } else {
      this.CurrentDate += tempDate.getDate();
    }

    this.getData();
    this.ImportValid = false;
  }

  getData() {
    Swal.fire({
      title: 'Loading Providers.',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });

    this.dbService.getAllProviders().subscribe((ret: any) => {
      if (ret != 'false') {
        this.ProvidersData.splice(0);
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach((element) => {
          let elementtemp = element.split(',');
          let temp = {
            ID: elementtemp[0],
            BoxSizeDirect: elementtemp[1],
            BatchSizeDirect: elementtemp[2],
            BoxSizeInDirect: elementtemp[3],
            BatchSizeInDirect: elementtemp[4],
          };

          this.ProvidersData.push(temp);
        });

        Swal.fire({
          title: 'Loading Branches.',
          showConfirmButton: false,
          toast: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });
        this.dbService.GetAllBranches().subscribe((ret: any) => {
          if (ret != 'false') {
            this.Branchs.splice(0);
            let a = (ret as string).split(';');
            a.splice(a.length - 1, 1);

            a.forEach((element) => {
              this.Branchs.push(element);
            });
            Swal.close();
          } else {
            Swal.close();
            this.PopupTitle = 'Error';
            this.DisplayErrormessage =
              'Please check your connection and try again';
            let element: HTMLButtonElement = document.getElementById(
              'ErrorButton'
            ) as HTMLButtonElement;
            element.click();
          }
        });
      } else {
        Swal.close();
        this.PopupTitle = 'Error';
        this.DisplayErrormessage = 'Please check your connection and try again';
        let element: HTMLButtonElement = document.getElementById(
          'ErrorButton'
        ) as HTMLButtonElement;
        element.click();
      }
    });
  }

  onFileChange(event: any) {
    Swal.fire({
      title: 'Loading Document',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });

    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>event.target;
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.data = <AOA>XLSX.utils.sheet_to_json(ws, { header: 1 });
      this.ValidateImport();
    };
    reader.readAsBinaryString(target.files[0]);
  }

  ValidateImport() {
    if (this.data[0][0] == undefined || this.data[0][0] == undefined) {
      Swal.close();
      this.excelFile = '';
      this.PopupTitle = 'Error';
      this.DisplayErrormessage =
        'Please make sure the first row contains the headings';
      let element: HTMLButtonElement = document.getElementById(
        'ErrorButton'
      ) as HTMLButtonElement;
      element.click();
      return;
    } else {
      if ((this.data[0][0] as string).toUpperCase() != 'BOX NUMBER') {
        this.excelFile = '';
        Swal.close();
        this.PopupTitle = 'Error';
        this.DisplayErrormessage =
          "Please make sure the FIRST colomn has Box numbers in it and the heading is:'BOX NUMBER'";
        let element: HTMLButtonElement = document.getElementById(
          'ErrorButton'
        ) as HTMLButtonElement;
        element.click();
        return;
      }
      if ((this.data[0][1] as string).toUpperCase() != 'SERIAL NUMBER') {
        this.excelFile = '';
        Swal.close();
        this.PopupTitle = 'Error';
        this.DisplayErrormessage =
          "Please make sure the SECOND colomn has Serial Numbers in it and the heading is:'SERIAL NUMBER'";
        let element: HTMLButtonElement = document.getElementById(
          'ErrorButton'
        ) as HTMLButtonElement;
        element.click();
        return;
      }

      if ((this.data[0][2] as string).toUpperCase() != 'BRICK NUMBER') {
        this.excelFile = '';
        Swal.close();
        this.PopupTitle = 'Error';
        this.DisplayErrormessage =
          "Please make sure the Third colomn has BRICK Numbers in it and the heading is:'BRICK NUMBER'";
        let element: HTMLButtonElement = document.getElementById(
          'ErrorButton'
        ) as HTMLButtonElement;
        element.click();
        return;
      }
    }

    var tempString = '';
    var tempBoxDetailsString = '';
    this.SERIALNUMBERs.splice(0);
    this.BrickNumbers.splice(0);
    this.BoxNUMBERs.splice(0);
    this.DataDisplay.splice(0);

    let temp = this.ProvidersData[this.Provider];

    for (let index = 1; index < this.data.length; index++) {
      //Boxno, Serialno, Batchno, Client, DateDist, Direct
      tempString =
        tempString +
        " ('" +
        this.data[index][0].toString().trim() +
        "','" +
        this.data[index][1].toString().trim() +
        "','','','','false','" +
        this.data[index][2].toString().trim() +
        "') ;";
      this.SERIALNUMBERs.push(this.data[index][1].toString().trim() as string);

      this.BrickNumbers.push(this.data[index][2].toString().trim() as string);

      if (!this.BoxNUMBERs.includes(this.data[index][0])) {
        this.BoxNUMBERs.push(this.data[index][0]);
        //Boxno, Provider, BoxSizeDirect, BatchSizeDirect, BoxSizeInDirect, BatchSizeInDirect, DateReceived, Status, Branch
        tempBoxDetailsString +=
          " ('" +
          this.data[index][0].toString().trim() +
          "','" +
          temp.ID +
          "','" +
          temp.BoxSizeDirect +
          "','" +
          temp.BatchSizeDirect +
          "','" +
          temp.BoxSizeInDirect +
          "','" +
          temp.BatchSizeInDirect +
          "','" +
          this.date +
          "','Recieved','" +
          this.Branch +
          "');";
      }

      this.DataDisplay.push({
        BoxNum: this.data[index][0].toString().trim(),
        SerialNum: this.data[index][1].toString().trim(),
        BrickNumber: this.data[index][2].toString().trim(),
      });
    }

    tempString = tempString.substr(0, tempString.length - 1);
    this.formData.set('SQL2', tempString);

    tempString = tempBoxDetailsString.substr(
      0,
      tempBoxDetailsString.length - 1
    );

    this.formData.set('SQL', tempString);

    this.ImportValid = true;

    Swal.close();
  }

  Next() {
    this.StageOne = false;
  }

  Back() {
    this.StageOne = true;
    this.Reset();
  }

  Reset() {
    this.Provider = 0;
    this.Branch = '';
    this.date = '';
    this.excelFile = '';
  }

  Done() {
    Swal.fire({
      title: 'Uploading Document.',
      showConfirmButton: false,
      toast: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });
    this.dbService.AddNewBox(this.formData).subscribe((ret: any) => {
      Swal.close();

      //Success. Results ; FailedBoxes ; SerialNumberResults ; FailedSerialNumbers
      let tempResult = String(ret);
      tempResult = tempResult.substring(tempResult.indexOf('.') + 1);

      let TempBoxResults = tempResult.substring(0, tempResult.indexOf(';'));
      tempResult = tempResult.substring(tempResult.indexOf(';') + 1);
      let TempFailedBoxes = tempResult
        .substring(0, tempResult.indexOf(';'))
        .split(',');
      tempResult = tempResult.substring(tempResult.indexOf(';') + 1);
      let TempFailedBoxesWithErrorReason = tempResult.substring(
        0,
        tempResult.indexOf(';')
      );
      TempFailedBoxesWithErrorReason =
        TempFailedBoxesWithErrorReason.substring(1);
      tempResult = tempResult.substring(tempResult.indexOf(';') + 1);
      let TempSerialNumberResults = tempResult.substring(
        0,
        tempResult.indexOf(';')
      );
      tempResult = tempResult.substring(tempResult.indexOf(';') + 1);
      let TempFailedSerialNumbers = tempResult.substring(
        0,
        tempResult.indexOf(';')
      );
      tempResult = tempResult.substring(tempResult.indexOf(';') + 1);
      let TempFailedSerialNumbersWithErrorReasons = tempResult.substring(1);

      //Remove unsuccessful Boxes
      let TempDisplayArray: {
        BoxNum: any;
        SerialNum: any;
        BrickNumber: any;
      }[] = [];
      var tempString = '';
      var tempBoxDetailsString = '';
      this.SERIALNUMBERs.splice(0);
      this.BrickNumbers.splice(0);
      this.BoxNUMBERs.splice(0);
      TempDisplayArray.splice(0);

      let tempProvidersDetails = this.ProvidersData[this.Provider];
      this.DataDisplay.forEach((element) => {
        if (TempFailedBoxes.includes(element.BoxNum)) {
          TempDisplayArray.push(element);

          //Boxno, Serialno, Batchno, Client, DateDist, Direct
          tempString =
            tempString +
            " ('" +
            element.BoxNum +
            "','" +
            element.SerialNum +
            "','','','','false','" +
            element.BrickNumber +
            "') ;";

          this.SERIALNUMBERs.push(element.SerialNum as string);
          this.BrickNumbers.push(element.BrickNumber as string);

          if (!this.BoxNUMBERs.includes(element.BoxNum)) {
            this.BoxNUMBERs.push(element.BoxNum);
            tempBoxDetailsString +=
              " ('" +
              element.BoxNum +
              "','" +
              tempProvidersDetails.ID +
              "','" +
              tempProvidersDetails.BoxSizeDirect +
              "','" +
              tempProvidersDetails.BatchSizeDirect +
              "','" +
              tempProvidersDetails.BoxSizeInDirect +
              "','" +
              tempProvidersDetails.BatchSizeInDirect +
              "','" +
              this.date +
              "','Recieved','" +
              this.Branch +
              "');";
          }
        } else if (
          TempFailedSerialNumbers.includes(element.SerialNum.toString())
        ) {
          TempDisplayArray.push(element);

          tempString =
            tempString +
            " ('" +
            element.BoxNum +
            "','" +
            element.SerialNum +
            "','','','','false','" +
            element.BrickNumber +
            "') ;";

          this.SERIALNUMBERs.push(element.SerialNum as string);
          this.BrickNumbers.push(element.BrickNumber as string);
        }
      });
      this.DataDisplay.splice(0);
      this.DataDisplay = [];
      tempString = tempString.substr(0, tempString.length - 1);
      this.formData.set('SQL2', tempString);

      tempString = tempBoxDetailsString.substr(
        0,
        tempBoxDetailsString.length - 1
      );
      this.formData.set('SQL', tempString);
      this.DataDisplay = TempDisplayArray;

      let tempEmailForm = new FormData();
      let tempMessage =
        'Username: ' +
        this.dbService.getUsername() +
        '<br>Provider: ' +
        tempProvidersDetails.ID +
        '<br><br>' +
        'Boxes imported: ' + TempBoxResults +
        '<br>' +
        'Serial numbers imported: ' + TempSerialNumberResults +
        '<br><br> Failed Box numbers: ' +
        TempFailedBoxesWithErrorReason.toString() +
        '; <br><br><br>' +
        'Failed Serial Numbers: ' +
        TempFailedSerialNumbersWithErrorReasons.toString();
      tempEmailForm.set('Message', tempMessage);

      Swal.fire({
        title:
          'Sending email containing results of imported boxes and serial numbers.',
        showConfirmButton: false,
        toast: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      this.dbService
        .EmailAdditionOfBoxDetails(tempEmailForm)
        .subscribe((ret: any) => {
          if (ret != 'Error') {
            Swal.close();
            this.PopupTitle = 'Successful import and result email sent.';
            this.DisplayErrormessage =
              TempBoxResults +
              ' Boxes and  ' +
              TempSerialNumberResults +
              ' serial numbers imported. Unsuccessful items have been left in the table.';
            let element: HTMLButtonElement = document.getElementById(
              'ErrorButton'
            ) as HTMLButtonElement;
            element.click();
          } else {
            console.log(ret);
            Swal.close();
            this.PopupTitle =
              'Something went wrong while trying to send email containing imported results.';
            this.DisplayErrormessage =
              'Please check your connection and try again';
            let element: HTMLButtonElement = document.getElementById(
              'ErrorButton'
            ) as HTMLButtonElement;
            element.click();
          }
          Swal.close();
        });
      //this.router.navigate(['PrepareBatches']);
    });
  }

  open(content: any) {
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = 'Closed with: ${result}';
        },
        (reason) => {
          this.closeResult = 'Dismissed ${this.getDismissReason(reason)}';
          //let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          //element.click();
        }
      );
  }
}
